@if (expandableContent) {
  <ur-info-overview
    #partnerPageBrandInfo
    [title]="partnerName"
    [description]="partnerDescription"
    [socialMediaLinks]="socialMediaLinks"
    [logo]="logo"
    [socialMediaTitle]="'commerce.followUsHere' | translate"
    [textHighlightTitle]="'commerce.contact' | translate"
    [highlights]="highlightItems"
    [formLink]="formLink() ?? undefined"
    data-cy="partner-page-brand-info-expandable-content">
  </ur-info-overview>

  <sirius-spacer></sirius-spacer>

  <commerce-content-expansion-container
    data-cy="content-expansion-container"
    (toggleDone)="scrollOnCollapse()">
    <ng-container ngProjectAs="expandable-content">
      @if (checklistGroups.length > 0) {
        <div
          class="capabilities-wrapper"
          data-cy="capabilities">
          <sirius-checklist [groups]="checklistGroups"></sirius-checklist>
        </div>
      }
      <sirius-grid>
        @if (availabilityColumns.length > 0) {
          <div
            class="availability-list"
            data-cy="availability-list">
            <sirius-heading
              [h]="4"
              textStyleSize="xs"
              [text]="'commerce.availability' | translate">
            </sirius-heading>
            <div class="availability-columns">
              @for (column of availabilityColumns; track column) {
                <ul class="availability-column">
                  @for (item of column; track item) {
                    <sirius-checkmark [config]="item"> </sirius-checkmark>
                  }
                </ul>
              }
            </div>
          </div>
        }
      </sirius-grid>
    </ng-container>
  </commerce-content-expansion-container>
} @else {
  <ur-info-overview
    [title]="partnerName"
    [description]="partnerDescription"
    [socialMediaTitle]="'commerce.followUsHere' | translate"
    [socialMediaLinks]="socialMediaLinks"
    [logo]="logo"
    [highlights]="highlightItems"
    [formLink]="formLink() ?? undefined"
    data-cy="partner-page-brand-info-only">
  </ur-info-overview>
  <sirius-spacer></sirius-spacer>
}
